export default "assets/images/hr-image-c37b19c3.png";